import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../Style/SearchPage.css';
import { searchUsers } from '../api/userApi';
import { useFollow } from '../hooks/useFollow';
import { useNavigate } from 'react-router-dom';

const SearchPage = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toggleFollow, loadingId } = useFollow();

  const handleFollowClick = (user) => {
    toggleFollow(
      user.id,
      user.isFollowing,
      user.requestSent, // ✅ pass requestSent
      ({ isFollowing, requestSent }) => {
        setResults((prev) =>
          prev.map((u) => (u.id === user.id ? { ...u, isFollowing, requestSent } : u)),
        );
      },
      ({ isFollowing, requestSent }) => {
        setResults((prev) =>
          prev.map((u) => (u.id === user.id ? { ...u, isFollowing, requestSent } : u)),
        );
      },
    );
  };

  // Debounce: Wait 300ms after user stops typing to call API
  useEffect(() => {
    const trimmed = query.trim();
    console.log(
      'query:',
      JSON.stringify(query),
      '| trimmed:',
      JSON.stringify(trimmed),
      '| length:',
      trimmed.length,
    );

    const delayDebounceFn = setTimeout(() => {
      if (trimmed.length > 1) {
        handleSearch();
      } else {
        setResults([]);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  const handleSearch = async (searchTerm = query.trim()) => {
    if (!searchTerm) return;
    setLoading(true);
    try {
      const data = await searchUsers(searchTerm); // ✅ use searchTerm, not query
      setResults(data);
    } catch (error) {
      console.error('Search failed:', error.response?.status, error.message);
    } finally {
      setLoading(false);
    }
  };

  // and call it with the trimmed value:
  useEffect(() => {
    const trimmed = query.trim();
    const delayDebounceFn = setTimeout(() => {
      if (trimmed.length > 1) {
        handleSearch(trimmed); // ✅ pass it directly
      } else {
        setResults([]);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  return (
    <div className="search-page-container">
      <div className="search-header">
        <h1>User Search</h1>
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder="Search by name..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          {loading && <div className="spinner-small"></div>}
        </div>
      </div>

      <div className="search-results">
        {results.map((user) => (
          <div key={user.id} className="athlete-card">
            <div className="athlete-info clickable" onClick={() => navigate(`/profile/${user.id}`)}>
              {user?.profilePicUrl ? (
                <img src={user.profilePicUrl} alt="Profile" className="profile-pic" />
              ) : (
                <div className="profile-pic-placeholder">
                  <span>👤</span>
                </div>
              )}
              <div>
                <h3 className="profile-name-text" style={{ fontSize: '1.0rem' }}>
                  {user.firstName} {user.lastName}
                </h3>
                <p>
                  {user.currentRank} • {user.totalXP} XP
                </p>
              </div>
            </div>
            <button
              type="button"
              disabled={loadingId === user.id}
              onClick={() => handleFollowClick(user)}
              className={user.isFollowing ? 'following-btn' : 'follow-btn'}
            >
              {loadingId === user.id ? (
                <span className="spinner-inline"></span>
              ) : user.isFollowing ? (
                'Following'
              ) : user.requestSent ? (
                'Requested' // ✅ add this
              ) : (
                'Follow'
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchPage;
